import React from 'react';
interface TrustBadgeProps {
  type: 'WIC' | 'EBT' | 'USDA' | 'SECURE';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function TrustBadge({
  type,
  className = '',
  size = 'md'
}: TrustBadgeProps) {
  const sizeClasses = {
    sm: 'text-[10px] px-1.5 py-0.5',
    md: 'text-xs px-2 py-1',
    lg: 'text-sm px-3 py-1.5'
  };
  if (type === 'WIC') {
    return <span className={`inline-flex items-center justify-center font-bold rounded-full bg-[#DC2626] text-white ${sizeClasses[size]} ${className}`} aria-label="WIC Eligible" title="WIC Eligible" data-id="element-256">
        WIC
      </span>;
  }
  if (type === 'EBT') {
    return <span className={`inline-flex items-center justify-center font-bold rounded-full bg-[#2563EB] text-white ${sizeClasses[size]} ${className}`} aria-label="EBT Eligible" title="EBT Eligible" data-id="element-257">
        EBT
      </span>;
  }
  if (type === 'USDA') {
    return <div className={`flex items-center gap-2 text-[#1E40AF] ${className}`} data-id="element-258">
        <div className="border-2 border-[#1E40AF] rounded-full p-1" data-id="element-259">
          <span className="font-bold text-xs block leading-none" data-id="element-260">USDA</span>
        </div>
        <span className="text-xs font-medium" data-id="element-261">Approved Partner</span>
      </div>;
  }
  if (type === 'SECURE') {
    return <div className={`flex items-center gap-1.5 text-[#1E40AF] bg-blue-50 px-3 py-1.5 rounded-full ${className}`} data-id="element-262">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-263">
          <rect width="18" height="11" x="3" y="11" rx="2" ry="2" data-id="element-264" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-265" />
        </svg>
        <span className="text-xs font-semibold" data-id="element-266">Secure Checkout</span>
      </div>;
  }
  return null;
}